module.exports = __webpack_public_path__ + "assets/img/c1.c91d8162.jpg";